/* eslint-disable max-len */
import { ComponentPropsWithoutRef, memo } from 'react';

function ArrowRightUpIcon2(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.385959 3.35623L29.5346 3.35623L29.5346 32.5048L25.5346 32.5048L25.5346 10.1847L4.46493 31.2543L1.6365 28.4259L22.7061 7.35623L0.385959 7.35623L0.385959 3.35623Z"
        fill="#1D1D1D"
      />
    </svg>
  );
}

export default memo(ArrowRightUpIcon2);
